import { render, staticRenderFns } from "./AppHeaderBase.vue?vue&type=template&id=3785719c&scoped=true"
import script from "./AppHeaderBase.vue?vue&type=script&lang=js"
export * from "./AppHeaderBase.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderBase.vue?vue&type=style&index=0&id=3785719c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3785719c",
  null
  
)

export default component.exports